import { useRef, useState, useEffect } from 'react';
import { Avatar, Box, IconButton, Stack, SvgIcon } from '@mui/material';
import { MenuOutlined } from '@mui/icons-material';
import { useLocation } from 'react-router';

import AccountPopover from './accountPopover';
import CustomTypography from '../../Typography/typography';
import styles from '../../../assets/styles/adminHeader';

let SIDE_NAV_WIDTH = 260;

const Header = (props: any) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1200);
  const classes = styles();
  SIDE_NAV_WIDTH = props.sideBar ? 260 : 0;
  const anchorRef = useRef(null);
  const location = useLocation();
  const [user, setUser] = useState(
    JSON.parse(decodeURIComponent(localStorage.getItem('profile')!))
  );
  const [open, setOpen] = useState(false);

  const handlePopUp = () => {
    setOpen(!open);
  };

  const handleSideBar = () => {
    props.setSideBar();
  };

  useEffect(() => {
    setUser(JSON.parse(decodeURIComponent(localStorage.getItem('profile')!)));
    window.addEventListener('resize', () =>
      setIsDesktop(window.innerWidth > 1200)
    );
    return () =>
      window.removeEventListener('resize', () =>
        setIsDesktop(window.innerWidth > 1200)
      );
  }, [location]);

  return (
    <>
      <Box
        component='header'
        sx={{
          left: {
            lg: `${SIDE_NAV_WIDTH}px`,
          },
          width: {
            lg: `calc(100% - ${SIDE_NAV_WIDTH}px)`,
          },
        }}
        className={classes.box}
      >
        <Stack className={classes.stack}>
          <Stack>
            {
              <IconButton onClick={handleSideBar}>
                <SvgIcon fontSize='small' className={classes.svgIcon}>
                  {<MenuOutlined />}
                </SvgIcon>
              </IconButton>
            }
          </Stack>
          <Stack className={classes.user}>
            <CustomTypography>{user?.fullName}</CustomTypography>
            <Avatar
              onClick={handlePopUp}
              ref={anchorRef}
              className={classes.avatar}
              src='/assets/avatars/avatar-anika-visser.png'
            />
          </Stack>
        </Stack>
      </Box>
      <AccountPopover
        anchorEl={anchorRef.current}
        open={open}
        onClose={handlePopUp}
      />
    </>
  );
};

export default Header;
